import React, { useEffect, useState } from 'react';
import './CardsCantidad.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUtensils, faImage, faAddressBook, faThList, faTag } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import baseURL from '../../url';
import { useData } from '../../DataContext';
import { usePlan } from '../../PlanContext';
import { ruta } from '../../paths';
export default function CardsCantidad() {
    const { productos, categorias, contacto, banners, codigos } = useData();
    const { isPlus } = usePlan();
    const [usuarios, setUsuarios] = useState([]);

    useEffect(() => {
        cargarUsuarios();
    }, []);

    const cargarUsuarios = () => {
        fetch(`${baseURL}/usuariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setUsuarios(data.usuarios || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };
    return (
        <div className='CardsCantidad'>

            <Anchor to={ruta('/dashboard/usuarios')} className='cardCantidad'>
                <FontAwesomeIcon icon={faUser} className='icons' />
                <div className='deColumn'>

                    <h3>Usuarios</h3>
                    <h2>{usuarios.length}</h2>
                </div>

            </Anchor>
            <Anchor to={ruta('/dashboard/productos')} className='cardCantidad' >
                <FontAwesomeIcon icon={faUtensils} className='icons' />
                <div className='deColumn'>

                    <h3>Productos</h3>
                    <h2>{productos.length}</h2>
                </div>

            </Anchor>
            <Anchor to={ruta('/dashboard/banners')} className='cardCantidad' >
                <FontAwesomeIcon icon={faImage} className='icons' />
                <div className='deColumn'>

                    <h3>Banners</h3>
                    <h2>{banners.length}</h2>
                </div>

            </Anchor>
            <Anchor to={ruta('/dashboard/categorias')} className='cardCantidad' >
                <FontAwesomeIcon icon={faThList} className='icons' />
                <div className='deColumn'>

                    <h3>Categorias</h3>
                    <h2>{categorias.length}</h2>
                </div>

            </Anchor>
            <Anchor to={ruta('/dashboard/contacto')} className='cardCantidad' >
                <FontAwesomeIcon icon={faAddressBook} className='icons' />
                <div className='deColumn'>
                    <h3>Contactos</h3>
                    <h2>{Array.isArray(contacto) ? contacto.length : (contacto ? 1 : 0)}</h2>
                </div>

            </Anchor>
            {isPlus && (
                <Anchor to={ruta('/dashboard/codigos')} className='cardCantidad' >
                    <FontAwesomeIcon icon={faTag} className='icons' />
                    <div className='deColumn'>
                        <h3>Codigos</h3>
                        <h2>{codigos.length}</h2>
                    </div>

                </Anchor>
            )}

        </div>
    )
}
